// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Shell from './Shell';
import { initializeClarityFromEnv } from '@applet-nsight/utils/clarity';
import * as serviceWorkerRegistration from '@applet-nsight/serviceWorkerRegistration';

// Analytics only when explicitly enabled in production
initializeClarityFromEnv();
serviceWorkerRegistration.register();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Shell />
  </React.StrictMode>
);
